import * as axios from './Axios'
import { API } from '@/environment'
const VPREFIX = 'admin/venue'
const PREFIX = 'quickbook'

export const _list = company_id => axios.get(`${PREFIX}/venues-list?company_id=${company_id}`)
export const _enableQuickBookQR = (data) => axios.post(`${PREFIX}/enable`, data)
export const _updateQuickBookSettings = (data) => axios.put(`${PREFIX}/update-settings`, data)
// export const _removeQuickBookQR = (data) => axios.delWithBody(`${PREFIX}/disable/`, data )

export const _removeQuickBookQR = (data) => axios.delWithBody(`${PREFIX}/disable/${data.venue_id}`, { data })
